<template>
    <div class="pay-success">
        <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-square-success" />
        </svg>
        <div class="txt">
            <p>随喜功德</p>
            <p>支付成功</p>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                
            }
        },
        methods: {
            
        },
        components: {
            
        }
    }
</script>

<style lang="less">
    @import "@/assets/style/vars.less";
    .pay-success {
        padding: 30px 0;
        text-align: center;
        .icon {
            width: 60px;
            height: 60px;
        }
        .txt {
            margin-top: 20px;
            font-family: "喜鹊聚珍体";
            font-size: 22px;
            color: @title-color;
            display: flex;
            align-items: center;
            justify-content: center;
            p {
                width: 30px;
            }
        }
    }
</style>
